/**
 * 3D단지투어 호패널 공급유형별 노출 문구 (HGNN-14295, PRD §5.1)
 *
 * 규칙:
 * - 공급유형이 '분양'일 때만 가격을 노출한다 (P-3DHO-001). 그 외 공급유형은
 *   호별·룸타입 분양가가 존재하더라도 가격을 노출하지 않고 아래 문구로 대체한다.
 * - '분양'이지만 호별·룸타입 분양가가 모두 없으면 NO_PRICE_NOTICE로 대체한다 (P-3DHO-002).
 * - 모든 문구는 6글자 이내 (C-3DHO-001).
 * - '분양전환'은 이번 작업 범위 밖(미정의 영역: 구분값·문구 없음)이라 별도 처리하지 않는다.
 */

/** 분양 세대인데 분양가가 없을 때, 그리고 구분불가 세대에 사용하는 문구 (6자). */
export const NO_PRICE_NOTICE = '분양가미확인';

/**
 * 공급유형 → 가격 미노출 시 표시 문구.
 * '분양'은 가격이 없을 때만 NO_PRICE_NOTICE를 쓰므로 이 값을 참조한다.
 */
export const supplyTypeNotice: Record<string, string> = {
  분양: NO_PRICE_NOTICE,
  조합: '조합원세대',
  구분불가: NO_PRICE_NOTICE,
  임대: '거래불가세대',
  기타: '회사보유세대',
};
